import { EnvironmentOutlined } from '@ant-design/icons';
import { type IAddress } from '@mahawi/eshop-common/src/types';
import React, { useState } from 'react';

import { COLOR } from '../theme/tokens';
import { AddressMapDrawer } from './order/address-map-drawer';

interface IOpenMapButtonProps {
  address: IAddress;
}

export default function OpenMapButton({
  address,
}: IOpenMapButtonProps): React.ReactElement {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <EnvironmentOutlined
        style={{ color: COLOR.locationPin, cursor: 'pointer' }}
        onClick={(): void => setOpen(true)}
      />
      {open && (
        <AddressMapDrawer
          address={address}
          open={open}
          onClose={(): void => setOpen(false)}
        />
      )}
    </>
  );
}
